import { useState } from 'react'
import CardBottom from './common/CardBottom'
import Calendar from './common/Calendar'
import CloseBtn from './common/CloseBtn'
import CardRow from './common/CardRow'
import AddToShopListBtn from './common/AddToShopListBtn'
import Market from '../../assets/icons/market-icon.svg'
import { MapStore, SelectionStore } from '../../store'
import { useObserver } from 'mobx-react'
import { formatDateDot, formatTime } from '../../util'
import { useText } from '../../texts'

function ShopCard({ show, position, shop }) {
  const t = useText()
  const statusClass = {
    Выполнено: 'success',
    'В процессе': 'warning',
    Заявка: 'error',
    'Не назначено': 'error',
  }[shop ? shop.status : 'Не назначено']
  const isOpenStatus = ['Заявка', 'Не назначено'].includes(shop?.status)
  const [showCalendar, setShowCalendar] = useState(false)
  const infoActions = (
    <div className="card__bottom">
      <div
        className="calendar__btn"
        onClick={() => setShowCalendar(!showCalendar)}
      >
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9186 0.603004C13.8728 0.262469 13.5831 0 13.2326 0C12.8503 0 12.5403 0.312359 12.5403 0.697674V1.46902H6.46814V0.697674L6.46182 0.603004C6.41598 0.262469 6.12632 0 5.77583 0C5.39348 0 5.08353 0.312359 5.08353 0.697674V1.48634C2.24655 1.68173 0.5 3.51992 0.5 6.48579V14.9041C0.5 18.0872 2.45834 20 5.59625 20H13.4036C16.5453 20 18.4999 18.1193 18.4999 14.9744V6.48579C18.509 3.51886 16.768 1.68119 13.9249 1.48626V0.697674L13.9186 0.603004ZM12.5403 2.86437V3.75887L12.5466 3.85354C12.5925 4.19407 12.8821 4.45654 13.2326 4.45654C13.615 4.45654 13.9249 4.14418 13.9249 3.75887V2.88499C15.9935 3.0571 17.122 4.30274 17.1153 6.48365V6.88768H1.88461V6.48579C1.88461 4.30626 3.01925 3.05798 5.08353 2.88513V3.75887L5.08985 3.85354C5.13569 4.19407 5.42535 4.45654 5.77583 4.45654C6.15818 4.45654 6.46814 4.14418 6.46814 3.75887V2.86437H12.5403ZM1.88461 8.28303V14.9041C1.88461 17.3067 3.21352 18.6047 5.59625 18.6047H13.4036C15.7946 18.6047 17.1153 17.3338 17.1153 14.9744L17.1153 8.28303H1.88461ZM14.3012 11.2183C14.3012 10.833 13.9912 10.5206 13.6089 10.5206L13.5064 10.527C13.1685 10.5732 12.908 10.8651 12.908 11.2183C12.908 11.6036 13.218 11.916 13.6089 11.916L13.7028 11.9096C14.0407 11.8634 14.3012 11.5715 14.3012 11.2183ZM9.51278 10.5206C9.89513 10.5206 10.2051 10.833 10.2051 11.2183C10.2051 11.5715 9.94463 11.8634 9.60672 11.9096L9.51278 11.916C9.12187 11.916 8.81192 11.6036 8.81192 11.2183C8.81192 10.8651 9.07237 10.5732 9.41028 10.527L9.51278 10.5206ZM6.10043 11.2183C6.10043 10.833 5.79047 10.5206 5.40812 10.5206L5.30563 10.527C4.96772 10.5732 4.70727 10.8651 4.70727 11.2183C4.70727 11.6036 5.01722 11.916 5.39957 11.916L5.50207 11.9096C5.83998 11.8634 6.10043 11.5715 6.10043 11.2183ZM13.6089 14.136C13.9912 14.136 14.3012 14.4484 14.3012 14.8337C14.3012 15.1869 14.0407 15.4788 13.7028 15.525L13.6089 15.5314C13.218 15.5314 12.908 15.219 12.908 14.8337C12.908 14.4805 13.1685 14.1886 13.5064 14.1424L13.6089 14.136ZM10.2051 14.8337C10.2051 14.4484 9.89513 14.136 9.51278 14.136L9.41028 14.1424C9.07237 14.1886 8.81192 14.4805 8.81192 14.8337C8.81192 15.219 9.12187 15.5314 9.51278 15.5314L9.60672 15.525C9.94463 15.4788 10.2051 15.1869 10.2051 14.8337ZM5.40812 14.136C5.79047 14.136 6.10043 14.4484 6.10043 14.8337C6.10043 15.1869 5.83998 15.4788 5.50207 15.525L5.39957 15.5314C5.01722 15.5314 4.70727 15.219 4.70727 14.8337C4.70727 14.4805 4.96772 14.1886 5.30563 14.1424L5.40812 14.136Z"
          />
        </svg>
        {t('visit-calendar')}
      </div>
    </div>
  )
  const historyActions = (
    <div
      className="card__bottom"
      style={{ display: isOpenStatus ? 'flex' : 'none' }}
    >
      <button
        style={{ flexGrow: '1' }}
        onClick={() => {
          SelectionStore.startShopSelection(shop)
        }}
        className="btn btn-secondary"
      >
        {t('select-shopper')}
      </button>
      <AddToShopListBtn shop={shop} />
    </div>
  )
  const showShopper = () => {
    if (shop.shopper.lat && shop.shopper.lng) {
      MapStore.goToPlace(shop.shopper.lat, shop.shopper.lng, true)
    }
    MapStore.setActiveMarker({ ...shop.shopper, type: 'user' })
  }

  return useObserver(() => (
    <>
      <div
        className={`marker-wrapper full-card  ${
          show ? `show ${position}` : ''
        }`}
      >
        <div className="marker-card full shop">
          {show && (
            <>
              <CloseBtn
                click={() => {
                  MapStore.clearActiveMarker()
                  setShowCalendar(false)
                }}
              />
              <div className="marker-card__updated">
                {formatDateDot(shop.updatedAt)}
                <br />
                {formatTime(shop.updatedAt)}
              </div>
              <div className="marker-card__avatar">
                <img src={Market} alt="avatar" />
              </div>

              <div className="marker-card__fullname">{shop.client}</div>
              <div className="marker-card__address">
                {shop.location?.address}
              </div>

              <hr className="line" />
              <div className="block-custom-scroll">
                <CardRow label={t('visit-location')} value={shop.storeId} />
                <div className="status">
                  <CardRow
                    label={t('status')}
                    value={t(shop.status)}
                    valueClass={statusClass}
                  />
                </div>
                <CardRow
                  label={t('rate')}
                  value={shop.payRate + ' ' + shop.currency}
                />
                <CardRow
                  label={t('shopper-login')}
                  value={
                    shop.shopperLogin && (
                      <span className="active" onClick={showShopper}>
                        {shop.shopperLogin}
                      </span>
                    )
                  }
                />

                <hr className="line" />
                <CardRow
                  label={t('visit-scenario')}
                  value={shop.description}
                  isTwoLines
                />
                <CardRow
                  label={t('visit-summary')}
                  value={shop.instruction}
                  isTwoLines
                />
                <div style={{ marginTop: 'auto' }}></div>
                <CardBottom
                  infoListData={{
                    [t('step')]: shop?.exception?.step,
                    [t('rotation')]: shop?.exception?.rotationTimeDays,
                    [t('start')]: shop?.exception?.startDate
                      ? formatDateDot(shop.exception.startDate)
                      : shop.startDate
                      ? formatDateDot(shop.startDate)
                      : '',
                    [t('end')]: shop?.exception?.dueDate
                      ? formatDateDot(shop.exception.dueDate)
                      : shop.dueDate
                      ? formatDateDot(shop.dueDate)
                      : '',
                    '': ' ',
                  }}
                  infoActions={infoActions}
                  history={shop.history}
                />
              </div>
              {historyActions}
            </>
          )}
        </div>
        <Calendar
          value={
            shop?.exception?.banedDays
              ? shop.exception.banedDays.split(' ').map((d) => {
                  let date = new Date(d)
                  return {
                    day: date.getDate(),
                    month: date.getMonth() + 1,
                    year: date.getFullYear(),
                  }
                })
              : []
          }
          show={showCalendar}
          close={() => setShowCalendar(false)}
        />
      </div>
    </>
  ))
}

export default ShopCard
